import * as React from 'react';
import Typography from '@mui/material/Typography';
import { DateTimePicker } from '@mui/x-date-pickers-pro';
import { format } from 'date-fns';
import { cx } from '../../../helpers/global';

type Props = {
  onChange: (value: Date) => void;
  closeModal?: () => void;
};

export default function CustomTime({ onChange, closeModal }: Props) {
  const [showCustomDate, setShowCustomDate] = React.useState(false);
  const [startDate, setStartDate] = React.useState<Date>();

  function clickHandle(datetime: Date) {
    onChange(datetime);
    closeModal?.();
  }

  return (
    <>
      {!showCustomDate && (
        <div
          role="presentation"
          className={cx('time-item', startDate && 'selected')}
          onClick={() => {
            setShowCustomDate(true);
            setStartDate(undefined);
          }}>
          <Typography variant="h3">
            {startDate ? format(startDate, 'MM/dd/yyyy h:mma') : 'Custom date'}
          </Typography>
        </div>
      )}

      {showCustomDate && (
        <DateTimePicker
          onChange={(...args) => {
            const [value, context] = args;
            const isInvalid = !!context.validationError;
            if (isInvalid || !value) return;
            setStartDate(value);
            clickHandle(value);
          }}
        />
      )}
    </>
  );
}
